export default __webpack_public_path__ + "static/media/bxl-docker.f3a1645f.svg";